<ng-container *ngIf="showPrompt">
  <h2 mat-dialog-title class="w-75">{{ message }}</h2>
  <mat-dialog-actions align="center" class="m-0">
    <button
      mat-raised-button
      color="primary"
      (click)="onConfirmClick()"
      tabindex="1"
      class="rounded-0 px-5"
    >
      {{ confirmButtonText }}
    </button>
    <button
      mat-raised-button
      mat-dialog-close
      tabindex="-1"
      class="rounded-0 px-5"
    >
      {{ cancelButtonText }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #showConfirmation>
  <div class="confirmation-dialog-blk">
    <div class="confirmation-card shadow-none text-center">
      <span class="float-end" (click)="onConfirmClick()"
        ><button mat-icon-button><i class="mi mi-close"></i></button
      ></span>
      <div class="icon-holder">
        <section [angularLottie]="successJson" [loop]="true"></section>
      </div>
      <h4 class="confirmation-status">Hurray!</h4>
      <p class="confirmation-desc">
        A confirmation message was sent successfully
      </p>
    </div>
  </div>
</ng-template>
<ng-container *ngIf="isShowConfirmation">
  <ng-container *ngTemplateOutlet="showConfirmation"></ng-container>
</ng-container>
